export default __webpack_public_path__ + "static/media/patrol_user.4b1822e1.jpg";